export const TIME_SELECTION_REMOVE_BUTTON_ID = 'CalendarSidePanel_RemoveTimeSelection';
